export default __webpack_public_path__ + "static/media/distribution.bd303120.svg";